import { useLazyQuery, useMutation } from "@apollo/client";
import {
  Avatar,
  Button,
  Checkbox,
  Collapse,
  message,
  Popover,
  Radio,
  Skeleton,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import { CREATE_LEAD_OPPORTUNITY, OPT_OUT_LEAD, UPDATE_LEAD } from "../../../graphql/mutation";
import { GET_LEAD_OPPORTUNITIES_BY_IDS } from "../../../graphql/query";
import useLang from "../../../hooks/useLang";
import DownIcon from "../../../icons/DownIcon";
import AddLeadIcon from "../../../icons/js/LeadProfileIcons/AddLeadIcon";
import AppCalendarIcon from "../../../icons/js/LeadProfileIcons/AppCalendarIcon";
import DollorIcon from "../../../icons/js/LeadProfileIcons/DollarIcon";
import NotesIcon from "../../../icons/js/LeadProfileIcons/NotesIcon";
import TaskListIcon from "../../../icons/js/LeadProfileIcons/TaskListIcon";
import { EditPencilIcon } from "../../../icons/js/PencilIcon";
import { PhoneIcon12 } from "../../../icons/js/PhoneIconJSX";
import PlusOutLinedJSX from "../../../icons/js/PlusOutLinedJSX";
import { AccessPermissionAction } from "../../../library/constants";
import { checkAccessPermission, closeDialog, openDialog } from "../../../library/helpers";
import { setSelectedLeadRedux } from "../../../redux/slices/leadSlice";
import { setLoaderStatus } from "../../../redux/slices/loaderSlice";
import { setLocationIdSlice } from "../../../redux/slices/locationSlice";
import { convertToInitials } from "../../layoutComponent/layoutHelpers";
import AppointmentList from "../appointmentList";
import MergeLeadOpportunityModal from "../mergeLeadOpportunityModal";
import { AboutThisLead } from "./AboutThisLead";
import { LeadNotes } from "./LeadNotes";
import { NameForm } from "./NameForm";
import { NotesDrawer } from "./NotesDrawer";
import { TaskDrawer } from "./TaskDrawer";
import CampignListView from "./leadCampaigns/campignListView";
import LeadConsent from "./leadConsent";
import LeadEditDrawer from "./leadEditDrawer";
import { LeadTaskList } from "./leadTask";
import { OpportunityDrawer } from "./opporotunityLayer/opportunityDrawer";
import OpportunityLayer from "./opporotunityLayer/opportunityLayer";

const LeadProfile = props => {
  const {
    socket,
    handleAddAppointment,
    setConnection,
    handleAddPhoneClick,
    setActiveOpp,
    refetchAppointment,
    handleSendConsentClick,
    handleActiveToggle,
    user,
    updateStatusLoading = false,
    setFilters,
    setRefetchAppointment,
    refetchLeads,
    isAppointmentChangeFromLead,
    disableConcentClick,
    consentLoader,
    statusList,
    crmIntegration,
    crmIntegrationData,
    handleLeadDetailProfile,
    setIsClickonPotentialDuplicate,
    getLeadDetail,
    eventId,
    spinner,
    refetchLeadDetails = () => {},
    setLeadList,
    leadList,
    getMessages,
    activeOpportunity,
    showAdd = true,
    languages,
    refreshLeadListData,
  } = props;
  const dispatch = useDispatch();
  const nameEditFormRef = useRef();

  const [visibleMergeOpportunityModal, setVisibleMergeOpportunityModal] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState();
  const [doNotMerge, setDoNotMerge] = useState({
    merged: false,
  });
  const [records, setRecords] = useState([]);
  const [duplicateRecord, setDuplicateRecord] = useState([]);

  const fields = (records?.length > 0 ? Object.keys(records[0]) : []).filter(key => key !== "id");

  const [lang] = useLang();
  const [showNameEdit, setshowNameEdit] = useState(false);
  const [liveCampaign, setliveCampaign] = useState(false);
  const [opportunityDrawer, setopportunityDrawer] = useState({
    open: false,
    item: {},
  });
  const [leadFormDrawer, setleadFormDrawer] = useState({
    open: false,
    item: {},
  });
  const { selectedLead, selectedLeadId } = useSelector(state => state.lead);
  const canEdit = checkAccessPermission(AccessPermissionAction.LEAD_ADD_EDIT);
  const canViewAppointment = checkAccessPermission(AccessPermissionAction.APPOINTMENT_VIEW);
  const setSelectedLead = lead => {
    dispatch(setSelectedLeadRedux(lead));
  };

  const [getLeadOpportunities, { loading: getOpportunityLoader }] = useLazyQuery(
    GET_LEAD_OPPORTUNITIES_BY_IDS
  );

  useEffect(() => {
    const updatedRecords = records?.map((record, index) => {
      const recordKey = `record${index + 1}`;

      if (doNotMerge[recordKey]) {
        return {
          ...record,
          name: { ...record.name, disabled: true, selected: false },
          type: { ...record.type, disabled: true, selected: false },
          location: { ...record.location, disabled: true, selected: false },
          vehicle: { ...record.vehicle, disabled: true, selected: false },
          owner: { ...record.owner, disabled: true, selected: false },
          source: { ...record.source, disabled: true, selected: false },
          status: { ...record.status, disabled: true, selected: false },
        };
      }

      if (Object.hasOwn(doNotMerge, recordKey)) {
        return {
          ...record,
          name: { ...record.name, disabled: false, selected: false },
          type: { ...record.type, disabled: false, selected: false },
          location: { ...record.location, disabled: false, selected: false },
          vehicle: { ...record.vehicle, disabled: false, selected: false },
          owner: { ...record.owner, disabled: false, selected: false },
          source: { ...record.source, disabled: false, selected: false },
          status: { ...record.status, disabled: false, selected: false },
        };
      }

      return record;
    });

    setRecords(updatedRecords);
  }, [doNotMerge]);

  const [leadNotesData, setleadNotesData] = useState({
    open: false,
    leadNote: null,
    selectedLead: null,
    mode: "",
  });
  const [createLeadOpportunity, { loading: createLeadOpportunityLoader }] =
    useMutation(CREATE_LEAD_OPPORTUNITY);

  const [optOutLead, { loading: optedOutLoader }] = useMutation(OPT_OUT_LEAD, {
    onCompleted: res => {
      if (res.optOutLead.statusCode === 200) {
        message.success(res.optOutLead.message);
        getLeadDetail({ variables: { leadId: +selectedLead?.id } });
      } else {
        message.error(res.optOutLead.message);
      }
    },
  });
  const [updateLead, { loading: updateLeadLoader }] = useMutation(UPDATE_LEAD);
  const handleOptedOut = async () => {
    dispatch(setLoaderStatus({ open: true }));
    await optOutLead({ variables: { leadId: +selectedLead?.id } });
    dispatch(setLoaderStatus({ open: false }));
    closeDialog("confirmDialog");
  };

  const handleLeadClick = (leadId, locationId) => {
    if (selectedLead?.id === leadId) {
      return;
    }
    if (+sessionStorage.getItem("currentLocationId") !== +locationId) {
      localStorage.setItem("changedLocationLeadId", leadId);
      sessionStorage.setItem("currentLocationId", locationId);
      setSelectedLead({});
      dispatch(setLocationIdSlice({ locationId: locationId }));
      setIsClickonPotentialDuplicate(true);
      refetchLeads();
      return;
    }

    handleLeadDetailProfile(leadId);
  };

  const handlePotentialLeadPopup = () => {
    openDialog("potentialDuplicateLeads", {
      dialogHeader: lang.potentialDuplicateLeads,
      setModalVisible: handlePotentialLeadPopup,
      isFromActivity: true,
      leadId: selectedLead?.id,
      selectedLeadPotentialIds: selectedLead?.phoneNumbers[0]?.potentialLeads,
      handleLeadClick: handleLeadClick,
      refetchLeads: refetchLeads,
      crmIntegrationData: crmIntegrationData,
      isFromLeadCenter: false,
      crmIntegrationType: crmIntegration,
    });
  };

  const handleSocketMessage = event => {
    const data = JSON.parse(event.data);
    if (data.type === "webchat_disconnect") {
      setConnection(data.payload);
    }
  };

  useEffect(() => {
    if (socket) {
      // Add event listener to the socket.
      socket.addEventListener("message", handleSocketMessage);

      // Clean up function to remove the event listener.
      // This prevents multiple event listeners from being added every time the component re-renders.
      return () => {
        socket.removeEventListener("message", handleSocketMessage);
      };
    }
  }, []);

  const canAddEditOpportunity = checkAccessPermission(
    AccessPermissionAction.LEAD_OPPORTUNITY_MANAGEMENT_ADD_EDIT
  );

  const handleCheckboxChange = key => {
    setDoNotMerge(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderCheckboxes = index => (
    <Checkbox
      checked={doNotMerge[`record${index + 1}`]}
      onChange={() => handleCheckboxChange(`record${index + 1}`)}
      className="relative bottom-[120%] left-[1%]"
    >
      <span className="text-[#334155] text-xs">Do Not Merge</span>
    </Checkbox>
  );

  const selectFieldsAtIndex = i => {
    setRecords(prevRecords => {
      return prevRecords.map((record, index) => {
        if (index === i) {
          // Set selected: true for all fields in the specified index
          return {
            ...record,
            name: { ...record.name, selected: true },
            type: { ...record.type, selected: true },
            location: { ...record.location, selected: true },
            vehicle: { ...record.vehicle, selected: true },
            owner: { ...record.owner, selected: true },
            source: { ...record.source, selected: true },
            status: { ...record.status, selected: true },
          };
        }
        return {
          ...record,
          name: { ...record.name, selected: false },
          type: { ...record.type, selected: false },
          location: { ...record.location, selected: false },
          vehicle: { ...record.vehicle, selected: false },
          owner: { ...record.owner, selected: false },
          source: { ...record.source, selected: false },
          status: { ...record.status, selected: false },
        };
      });
    });
  };

  const handleRadioChange = (field, recordIndex) => {
    setRecords(prevRecords =>
      prevRecords.map((record, index) => ({
        ...record,
        [field]: {
          ...record[field],
          selected: index === recordIndex - 1,
        },
      }))
    );
  };

  const renderRadio = (field, record, recordIndex) => (
    <Radio
      onChange={() => handleRadioChange(field, recordIndex)}
      checked={record[field]?.selected}
      className="mr-2"
      disabled={record[field]?.disabled}
    >
      {record[field]?.value || "N/A"}
    </Radio>
  );

  const columns = [
    {
      title: "Field",
      dataIndex: "field",
      key: "field",
      className: "highlight-column",
      width: "200px",
      onCell: () => ({
        style: { backgroundColor: "#E2E8F0" }, // Background for cells
      }),
    },
    {
      title: "Merged Record",
      dataIndex: "merged",
      key: "merged",
      className: "highlight-column",
      width: "200px",
      render: (text, record) => record.merged || "N/A", // Display merged record
      onCell: () => ({
        style: { backgroundColor: "#E2E8F0" }, // Background for cells
      }),
    },
    ...records.map((_, index) => ({
      title: (
        <div style={{ textAlign: "center" }}>
          {renderCheckboxes(index)}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span className="text-[14px]">Record {index + 1}</span>
            <span
              className={`text-[#3B82F6] ml-2 text-[14px] cursor-pointer ${
                doNotMerge[`record${index + 1}`] ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={() => !doNotMerge[`record${index + 1}`] && selectFieldsAtIndex(index)}
            >
              Select All
            </span>
          </div>
        </div>
      ),
      dataIndex: `record${index}`,
      key: `record${index}`,
      render: (text, record) => {
        const fieldName = record.field; // Field like name, address, city
        return renderRadio(fieldName, records[index], index + 1);
      },
      onCell: () => ({
        style: { backgroundColor: "#FFFFFF" }, // Background for cells
      }),
    })),
  ];

  const tableData = fields.map(field => {
    const row = { field };
    const selectedRecord = records?.find(record => record[field]?.selected === true);
    row.merged = selectedRecord ? selectedRecord[field]?.value : records[0][field]?.value || "N/A";
    records?.forEach((record, index) => {
      row[`record${index}`] = record[field]?.value || "N/A";
    });

    return row;
  });

  function getIdsBySelectedField(data, fieldName) {
    return data.filter(item => item[fieldName]?.selected === true).map(item => item.id);
  }

  const findOpportunityById = id => {
    return duplicateRecord?.find(opportunity => opportunity.id === id);
  };

  const handleMerge = async () => {
    createLeadOpportunity({
      variables: {
        leadId: selectedLead?.id,
        leadOpportunityUsers:
          findOpportunityById(getIdsBySelectedField(records, "owner")[0])?.leadOpportunityUsers.map(
            item => ({
              id: +item.id,
              userTypeId: item.userTypeId,
              userType: item.userType?.name,
              userId: item.userId,
            })
          ) ||
          findOpportunityById(records[0]?.id)?.leadOpportunityUsers?.map(item => ({
            id: +item.id,
            userTypeId: item.userTypeId,
            userType: item.userType?.name,
            userId: item.userId,
          })),
        name:
          findOpportunityById(getIdsBySelectedField(records, "name")[0])?.name ||
          findOpportunityById(records[0]?.id)?.name,
        opportunityStatusId:
          findOpportunityById(getIdsBySelectedField(records, "status")[0])?.opportunityStatusId ||
          findOpportunityById(records[0]?.id)?.status,
        opportunityTypeId:
          findOpportunityById(getIdsBySelectedField(records, "type")[0])?.opportunityTypeId ||
          findOpportunityById(records[0]?.id)?.opportunityTypeId,
        locationId:
          findOpportunityById(getIdsBySelectedField(records, "location")[0])?.location?.id ||
          findOpportunityById(records[0]?.id)?.location?.id,
        opportunitySourceId:
          findOpportunityById(getIdsBySelectedField(records, "source")[0])?.opportunitySourceId ||
          findOpportunityById(records[0]?.id)?.opportunitySourceId,
        vehicleOfInterests:
          findOpportunityById(getIdsBySelectedField(records, "vehicle")[0])?.vehiclesOfInterest ||
          findOpportunityById(records[0]?.id)?.vehiclesOfInterest,
        potentialOpportunity: [
          ...findOpportunityById(records[0]?.id)?.potentialOpportunity,
          +records[0]?.id,
        ],
      },
      onCompleted: res => {
        if (res?.createLeadOpportunity?.statusCode === 200) {
          setVisibleMergeOpportunityModal(false);
          getLeadDetail({ variables: { leadId: +selectedLead?.id } });
        } else {
          message.error(res?.createLead?.message);
        }
      },
    });
  };

  // socket &&
  //   socket.on("webchat_disconnect", arg => {
  //     setConnection(arg);
  //   });
  const [leadTaskData, setleadTaskData] = useState({
    open: false,
    leadTask: null,
    selectedLead: null,
    mode: "",
  });
  const profileEmail =
    selectedLead &&
    selectedLead.emails &&
    selectedLead.emails.length > 0 &&
    selectedLead.emails.find(item => item?.isPrimary)?.email;

  const canAddTask = checkAccessPermission(AccessPermissionAction.TASK_MANAGEMENT_ADD_EDIT);

  const leadActions = [
    {
      label: "Opportu..",
      icon: <DollorIcon />,
      onClick: () => setopportunityDrawer({ open: true, item: selectedLead }),
    },
    {
      label: "Task",
      icon: <TaskListIcon />,
      onClick: () =>
        canAddTask
          ? setleadTaskData({ open: true, mode: "ADD", selectedLead })
          : message.info(lang.noTaskPermission),
    },
    {
      label: "Note",
      icon: <NotesIcon color="#334155" />,
      onClick: () =>
        setleadNotesData({
          ...leadNotesData,
          open: true,
          selectedLead,
          mode: "ADD",
        }),
    },
    { label: "Appoint...", icon: <AppCalendarIcon />, onClick: () => handleAddAppointment() },
    { label: "Call", icon: <PhoneIcon12 /> },
  ];
  const phoneArr = ["Mobile", "Work", crmIntegration === "DS" ? "Other" : "Home"];

  const profileSections = [
    {
      header: (
        <span className="flex-row-centered justify-between items-center">
          About this lead{" "}
          <Button
            size="small"
            onClick={e => {
              e.stopPropagation();
              setleadFormDrawer({
                open: true,
                lead: selectedLead,
                mode: "EDIT",
                showOpportunityForm: false,
                header: (
                  <div className="flex flex-col">
                    <span className="text-lg font-[600]">Modify Lead Information</span>
                  </div>
                ),
                setSelectedLead,
                setLeadList,
                refetch: () => {},
                refetchLead: () => {},
                getLeads: () => {},
                refetchLeadOpportunities: () => {},
              });
            }}
          >
            Edit
          </Button>
        </span>
      ),
      content: (
        <AboutThisLead
          leadList={leadList}
          getMessages={getMessages}
          setSelectedLead={setSelectedLead}
          setLeadList={setLeadList}
          languages={languages}
        />
      ),
    },
    {
      header: "Consents",
      content: (
        <LeadConsent
          consentLoader={consentLoader}
          selectedLead={selectedLead}
          disableConcentClick={disableConcentClick}
          handleSendConsentClick={handleSendConsentClick}
          user={user}
          optedOutLoader={optedOutLoader}
          handleOptedOut={handleOptedOut}
          updateStatusLoading={updateStatusLoading}
          handleActiveToggle={handleActiveToggle}
        />
      ),
    },
    {
      header: (
        <span className="flex-row-centered justify-between items-center">
          Notes{" "}
          <Button
            type="text"
            className="text-brand-500 gap-1 flex-row-centered"
            size="small"
            onClick={e => {
              e.stopPropagation();
              setleadNotesData({
                ...leadNotesData,
                open: true,
                selectedLead,
                mode: "ADD",
              });
            }}
          >
            <PlusOutLinedJSX />
            Add
          </Button>
        </span>
      ),
      content: (
        <LeadNotes
          setSelectedLead={setSelectedLead}
          leadNotesData={leadNotesData}
          setleadNotesData={setleadNotesData}
        />
      ),
    },
    {
      header: (
        <span className="flex-row-centered justify-between items-center">
          Tasks{" "}
          <Button
            type="text"
            className="text-brand-500 gap-1 flex-row-centered"
            size="small"
            disabled={!canAddTask}
            onClick={e => {
              e.stopPropagation();
              setleadTaskData({ open: true, mode: "ADD", selectedLead });
            }}
          >
            <PlusOutLinedJSX />
            Add
          </Button>
        </span>
      ),
      content: <LeadTaskList selectedLead={selectedLead} setleadTaskData={setleadTaskData} />,
    },
    {
      header: (
        <span className="flex-row-centered justify-between items-center">
          Appointments{" "}
          <Button
            type="text"
            className="text-brand-500 gap-1 flex-row-centered"
            size="small"
            onClick={e => {
              e.stopPropagation();
              handleAddAppointment();
            }}
          >
            <PlusOutLinedJSX />
            Add
          </Button>
        </span>
      ),
      content: (
        <AppointmentList
          width="80px"
          leadId={selectedLead?.id}
          selectedLead={selectedLead}
          isFromActiviytCenter
          refetch={refetchAppointment}
          isAppointmentChangeFromLead={isAppointmentChangeFromLead}
          onRefetch={() => setRefetchAppointment(true)}
          canView={canViewAppointment}
          setSelectedLead={setSelectedLead}
          leadOpportunities={selectedLead?.leadOpportunities}
          eventId={eventId}
          onClick={() => {
            handleLeadDetailProfile(selectedLead?.id);
          }}
          handleLeadDetailProfile={handleLeadDetailProfile}
          passUserIds={false}
          refreshLeadListData={refreshLeadListData}
        />
      ),
    },
    {
      header: (
        <span className="flex-row-centered justify-between items-center">
          Opportunities{" "}
          <Button
            type="text"
            className="text-brand-500 gap-1 flex-row-centered"
            size="small"
            onClick={e => {
              e.stopPropagation();
              setopportunityDrawer({ open: true, item: selectedLead });
            }}
          >
            <PlusOutLinedJSX />
            Add
          </Button>
        </span>
      ),
      content: (
        <Skeleton loading={spinner} active avatar>
          <OpportunityLayer
            leadId={selectedLead?.id}
            showLinks
            selectedLead={selectedLead}
            statusList={statusList}
            crmIntegrationType={crmIntegration}
            crmIntegrationData={crmIntegrationData}
            refetchLeads={refetchLeads}
            onMessageFilter={camapign => setFilters(camapign)}
            onRefetch={() => setFilters(null)}
            leadOpportunities={selectedLead?.leadOpportunities}
            leadFullname={selectedLead?.fullName}
            crmLeadObj={selectedLead?.crmLeadObj}
            leadUsers={selectedLead?.leadUsers}
            refetchLeadDetails={refetchLeadDetails}
            setActiveOpp={setActiveOpp}
            oppValue={activeOpportunity}
            setVisibleMergeOpportunityModal={value => setVisibleMergeOpportunityModal(value)}
            setRecords={setRecords}
            setDuplicateRecord={setDuplicateRecord}
            setSelectedOpportunityData={setSelectedOpportunity}
            setSelectedLead={setSelectedLead}
            getLeadOpportunities={getLeadOpportunities}
          />
        </Skeleton>
      ),
    },
    {
      header: (
        <div className="flex-row-centered items-center justify-between">
          <span>Campaign</span>
          {liveCampaign && (
            <Tag className="bg-green-500 text-white rounded-[19px] text-xs font-[600] px-2">
              Live
            </Tag>
          )}
        </div>
      ),
      content: (
        <CampignListView
          leadId={selectedLead?.id}
          showLinks
          onMessageFilter={camapign => setFilters(camapign)}
          onRefetch={() => setFilters(null)}
          handleLeadDetailProfile={handleLeadDetailProfile}
          setliveCampaign={setliveCampaign}
        />
      ),
    },
  ];
  const HorizontalLine = () => <div className="w-full h-[1px] bg-gray-200" />;
  return (
    <div>
      <div className="flex-col-centered gap-3 items-center">
        {showAdd && (
          <>
            <Button
              className="add-lead-btn w-full flex-row-centered items-center gap-2 justify-center text-brand-500 border-gray-200 border-[1px]"
              onClick={() =>
                (sessionStorage.getItem("currentLocationId") || "").includes(",")
                  ? message.info(lang.selectLocationFromDropdown)
                  : handleAddPhoneClick()
              }
            >
              <AddLeadIcon /> Add Quick Lead
            </Button>
            <HorizontalLine />
          </>
        )}
        {/* Profile Details start */}
        <div className="flex-col-centered gap-1 mb-6 items-center justify-center">
          <Avatar className="bg-error-400">{convertToInitials(selectedLead?.fullName)}</Avatar>
          <span
            className="text-lg flex items-center justify-center font-bold w-full"
            onMouseEnter={() => setshowNameEdit(true)}
            onMouseLeave={() => setshowNameEdit(false)}
          >
            <div className="flex items-center justify-center">
              <span className="ellipsis max-w-[200px] text-center">{selectedLead?.fullName}</span>
              {canEdit && (
                <Popover
                  trigger="click"
                  title="Edit Lead name"
                  placement="bottom"
                  content={
                    <NameForm
                      updateLead={updateLead}
                      loader={updateLeadLoader}
                      nameEditFormRef={nameEditFormRef}
                      setSelectedLead={setSelectedLead}
                    />
                  }
                >
                  <span ref={nameEditFormRef}>
                    <EditPencilIcon
                      className={`cursor-pointer ml-1 ${showNameEdit ? "visible" : "invisible"}`}
                      color="#3B82F6"
                    />
                  </span>
                </Popover>
              )}{" "}
            </div>
          </span>
          {/* Phone number view start */}
          <span>
            {selectedLead &&
            Array.isArray(selectedLead?.phoneNumbers) &&
            (selectedLead?.phoneNumbers || []).length > 0
              ? formatPhoneNumberIntl(
                  selectedLead.phoneNumbers.find(item => item?.isPrimary)?.phone ||
                    selectedLead.phoneNumbers.find(item => item.lookupType === "mobile")?.phone ||
                    ""
                )
              : ""}
          </span>
          {/* Phone number view end */}
          <Tooltip title={profileEmail ? "Send mail" : null}>
            <span
              onClick={() => profileEmail && window.open(`mailto:${profileEmail}`)}
              className={`${
                profileEmail ? "cursor-pointer text-brand-500 ellipsis max-w-[250px]" : ""
              }`}
            >
              {profileEmail || "N/A"}
            </span>
          </Tooltip>
        </div>

        <MergeLeadOpportunityModal
          visible={visibleMergeOpportunityModal}
          setVisible={setVisibleMergeOpportunityModal}
          handleMerge={handleMerge}
          loading={createLeadOpportunityLoader}
          dataLoader={getOpportunityLoader}
          columns={columns}
          tableData={tableData}
        />
        {/* Profile Details end */}
        {/* Profile action starts */}
        <div className="grid grid-cols-5 text-center w-full">
          {leadActions.map((item, index) => (
            <span
              key={index}
              onClick={() => item?.onClick && item?.onClick()}
              className=" cursor-pointer flex-col-centered items-center gap-1"
            >
              <div className="bg-gray-100 p-2 rounded-full border-[1px] border-solid border-grey-200 flex-row-centered items-start gap-2">
                {item.icon}
              </div>
              <span>{item.label}</span>
            </span>
          ))}
        </div>
        {/* Profile action end */}
        <HorizontalLine />
      </div>
      <Collapse
        expandIcon={panelProps => (
          <DownIcon
            className={`${
              panelProps.isActive ? "rotate-0" : "rotate-[-90deg]"
            } transition-all duration-300`}
          />
        )}
        defaultActiveKey={["0", "1", "5", "6"]}
        className="transparent-collapse w-full rounded-none"
      >
        {profileSections.map((item, index) => (
          <Collapse.Panel className="lead-profile-sections" key={index} header={item.header}>
            <div className="px-2">{item.content}</div>
          </Collapse.Panel>
        ))}
      </Collapse>
      <NotesDrawer
        key="key__notedraswer1"
        setSelectedLead={setSelectedLead}
        leadNotesData={leadNotesData}
        setleadNotesData={setleadNotesData}
      />
      <TaskDrawer
        setSelectedLead={setSelectedLead}
        leadTaskData={leadTaskData}
        setleadTaskData={setleadTaskData}
      />
      <OpportunityDrawer
        crmIntegrationType={crmIntegration}
        mode="ADD"
        opportunityDrawer={opportunityDrawer}
        refetch={refetchLeadDetails}
        // getLeads={refetchLeads}
        setopportunityDrawer={setopportunityDrawer}
        titleContent={
          <div className="flex flex-col">
            <span className="text-lg font-[600]">Add Opportunity for {selectedLead?.fullName}</span>
          </div>
        }
        key="opportunityDrawer-ADD"
      />
      <LeadEditDrawer drawerData={leadFormDrawer} setDrawerData={setleadFormDrawer} />
    </div>
  );
};

export default LeadProfile;
